import { useEffect, useState, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../controls/DashboardLayout";
import DashboardNavbar from "../../controls/DashboardNavbar";
import MDBox from "../../controls/MDBox";
import { Grid } from "@mui/material";
import { Card } from "react-bootstrap";
import MDTypography from "../../controls/MDTypography";
import ManualAyuda from "../../controls/ManualAyuda";
import MDButton from "../../controls/MDButton";
import DataTable from "../../controls/Tables/DataTable";
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import { postData, pathData, deleteData, getData } from "../../Utils/Http/api";
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function JudEstadoListar() {
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [dataVersion, setDataVersion] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [estado, setEstado] = useState("");
    const [subEstados] = useState([
        { id: 1, label: "GESTION" },
        { id: 2, label: "CAUTELAR" },
        { id: 3, label: "PROCESAL" }
    ]);
    const [selectedSubEstado, setSelectedSubEstado] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, msg: '', severity: 'success' });
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [filtroEstado, setFiltroEstado] = useState("");
    const [filtroSubEstado, setFiltroSubEstado] = useState(null);

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = {
                estado: filtroEstado || "",
                subEstado: filtroSubEstado?.id || ""
            };
            const res = await getData('/JudEstadoListar', params);
            const list = res?.value || [];
            
            const newColumns = [
                { Header: 'Estado y Sub Estado', accessor: 'detalle', align: 'left', width: '80%' },
                { Header: 'Acciones', accessor: 'action', align: 'center', width: '20%' }
            ];
            
            const data = list.map(item => {
                const detalle = (
                    <MDBox>
                        <MDTypography variant="h6" color="text" fontWeight="medium">
                            {item.estado}
                        </MDTypography>
                        <MDTypography variant="caption" color="info" fontWeight="medium">
                            Sub Estado: {item.subEstado || 'N/A'}
                        </MDTypography>
                    </MDBox>
                );
                const action = (
                    <MDBox display="flex" gap={1} alignItems="center" justifyContent="center">
                        <IconButton
                            size="small"
                            onClick={() => handleOpenEdit(item)}
                            aria-label="editar"
                        >
                            <EditIcon color="info" />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => { setDeleteId(item.idJudEstado); setOpenDelete(true); }}
                            aria-label="eliminar"
                        >
                            <DeleteIcon color="error" />
                        </IconButton>
                    </MDBox>
                );
                return {
                    id: item.idJudEstado,
                    detalle,
                    action
                };
            });

            setColumns(newColumns);
            setRows([...data]);
        } catch (ex) {
            console.error('Error cargando estados judiciales', ex);
            setSnackbar({ open: true, msg: 'Error al cargar los estados judiciales', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshKey]);

    const handleOpenAdd = () => {
        setEditMode(false);
        setCurrentItem(null);
        setEstado("");
        setSelectedSubEstado(null);
        setOpenDialog(true);
    };

    const handleLimpiarFiltros = () => {
        setFiltroEstado("");
        setFiltroSubEstado(null);
        setRefreshKey(prev => prev + 1);
    };

    const handleOpenEdit = async (item) => {
        setEditMode(true);
        setCurrentItem(item);
        setEstado(item.estado || "");
        const subEstado = subEstados.find(s => s.label === item.subEstado);
        setSelectedSubEstado(subEstado || null);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setCurrentItem(null);
        setEstado("");
        setSelectedSubEstado(null);
    };

    const handleSave = async () => {
        if (!estado.trim()) {
            setSnackbar({ open: true, msg: 'El estado es requerido', severity: 'warning' });
            return;
        }
        if (!selectedSubEstado) {
            setSnackbar({ open: true, msg: 'Debe seleccionar un sub estado', severity: 'warning' });
            return;
        }

        try {
            if (editMode) {
                const payload = {
                    idJudEstado: currentItem.idJudEstado,
                    estado: estado,
                    IDJudSubEstado: selectedSubEstado.id
                };
                const res = await pathData(`/JudEstadoUpdate`, payload);
                if (res?.isSuccess) {
                    setSnackbar({ open: true, msg: 'Estado judicial actualizado correctamente', severity: 'success' });
                    handleCloseDialog();
                    setDataVersion(prev => prev + 1);
                    setRefreshKey(prev => prev + 1);
                } else {
                    setSnackbar({ open: true, msg: res?.error || 'Error actualizando estado judicial', severity: 'error' });
                }
            } else {
                const payload = {
                    estado: estado,
                    IDJudSubEstado: selectedSubEstado.id
                };
                const res = await postData('/JudEstadoAlta', payload);
                if (res?.isSuccess) {
                    setSnackbar({ open: true, msg: 'Estado judicial creado correctamente', severity: 'success' });
                    handleCloseDialog();
                    setDataVersion(prev => prev + 1);
                    setRefreshKey(prev => prev + 1);
                } else {
                    setSnackbar({ open: true, msg: res?.error || 'Error creando estado judicial', severity: 'error' });
                }
            }
        } catch (ex) {
            console.error('Error guardando estado judicial', ex);
            setSnackbar({ open: true, msg: 'Error guardando estado judicial', severity: 'error' });
        }
    };

    const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

    const handleCancelDelete = () => {
        setDeleteId(null);
        setOpenDelete(false);
    };

    const handleConfirmDelete = async () => {
        if (!deleteId) return;
        try {
            const res = await deleteData(`/JudEstadoDelete/${deleteId}`);
            if (res?.isSuccess) {
                setSnackbar({ open: true, msg: 'Estado judicial eliminado correctamente', severity: 'success' });
                setOpenDelete(false);
                setDeleteId(null);
                setDataVersion(prev => prev + 1);
                setRefreshKey(prev => prev + 1);
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error eliminando estado judicial', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error eliminando estado judicial', ex);
            const msg = ex?.message || ex?.response?.data?.detail || 'Error eliminando estado judicial';
            setSnackbar({ open: true, msg, severity: 'error' });
        }
    };

    const PaperComponent = useCallback((props) => {
        return (
            <Draggable
                handle="#draggable-dialog-title"
                cancel={'[class*="MuiDialogContent-root"]'}
            >
                <Paper {...props} />
            </Draggable>
        );
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="secondary"
                                borderRadius="lg"
                                coloredShadow="secondary"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <MDTypography variant="h6" color="white">
                                    Estados Judiciales
                                </MDTypography>
                                <ManualAyuda seccion="Estados Judiciales" />
                            </MDBox>

                            <MDBox pt={3} py={3} px={2}>
                                {/* Filtros */}
                                <MDBox mb={3} display="flex" flexDirection="column" gap={2}>
                                    <MDBox display="flex" gap={2} flexWrap="wrap">
                                        <TextField
                                            label="Filtrar por Estado"
                                            value={filtroEstado}
                                            onChange={(e) => setFiltroEstado(e.target.value)}
                                            size="small"
                                            sx={{ minWidth: 250 }}
                                        />
                                        <Autocomplete
                                            options={subEstados}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={filtroSubEstado}
                                            onChange={(e, newValue) => setFiltroSubEstado(newValue)}
                                            renderInput={(params) => <TextField {...params} label="Filtrar por Sub Estado" size="small" />}
                                            sx={{ minWidth: 250 }}
                                        />
                                    </MDBox>
                                </MDBox>

                                <MDBox mb={2} display="flex" gap={1}>
                                    <MDButton
                                        onClick={handleOpenAdd}
                                        variant="gradient"
                                        color="success"
                                        startIcon={<AddIcon />}
                                    >
                                        Agregar Estado
                                    </MDButton>
                                    <MDButton
                                        onClick={() => setRefreshKey(prev => prev + 1)}
                                        variant="outlined"
                                        color="info"
                                        startIcon={<SearchIcon />}
                                    >
                                        Buscar
                                    </MDButton>
                                    <MDButton
                                        onClick={handleLimpiarFiltros}
                                        variant="outlined"
                                        color="warning"
                                    >
                                        Limpiar Filtros
                                    </MDButton>
                                </MDBox>

                                {loading ? (
                                    <MDBox display="flex" justifyContent="center" alignItems="center" py={6}>
                                        <CircularProgress />
                                    </MDBox>
                                ) : (
                                    <DataTable
                                        key={`${refreshKey}-${dataVersion}`}
                                        table={{ columns, rows }}
                                        isSorted={false}
                                        showTotalEntries
                                        canSearch={false}
                                        noEndBorder
                                        pagination={{ color: 'warning', variant: 'gradient' }}
                                    />
                                )}

                                {/* Dialog Add/Edit */}
                                <Dialog 
                                    open={openDialog} 
                                    onClose={(event, reason) => {
                                        if (reason !== 'backdropClick') {
                                            handleCloseDialog();
                                        }
                                    }}
                                    disableEscapeKeyDown
                                    fullWidth 
                                    maxWidth="sm"
                                    PaperComponent={PaperComponent}
                                    aria-labelledby="draggable-dialog-title"
                                >
                                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                                        {editMode ? 'Editar Estado Judicial' : 'Agregar Estado Judicial'}
                                    </DialogTitle>
                                    <DialogContent>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            <TextField
                                                label="Estado *"
                                                value={estado}
                                                onChange={(e) => setEstado(e.target.value)}
                                                fullWidth
                                                required
                                            />
                                            <Autocomplete
                                                options={subEstados}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={selectedSubEstado}
                                                onChange={(e, newValue) => setSelectedSubEstado(newValue)}
                                                disableClearable={false}
                                                freeSolo={false}
                                                renderInput={(params) => <TextField {...params} label="Sub Estado *" inputProps={{...params.inputProps, readOnly: true}} />}
                                            />
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCloseDialog}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleSave}>
                                            Guardar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                {/* Dialog Confirm Delete */}
                                <Dialog 
                                    open={openDelete} 
                                    onClose={(event, reason) => {
                                        if (reason !== 'backdropClick') {
                                            handleCancelDelete();
                                        }
                                    }}
                                    disableEscapeKeyDown
                                    fullWidth 
                                    maxWidth="xs"
                                >
                                    <DialogTitle>Eliminar Estado Judicial</DialogTitle>
                                    <DialogContent>
                                        <MDBox>
                                            <MDTypography>¿Confirma que desea eliminar este estado judicial?</MDTypography>
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCancelDelete}>
                                            Cancelar
                                        </MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleConfirmDelete}>
                                            Eliminar
                                        </MDButton>
                                    </DialogActions>
                                </Dialog>

                                <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
                                    <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} elevation={6} variant="filled">
                                        {snackbar.msg}
                                    </MuiAlert>
                                </Snackbar>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default JudEstadoListar;
